module.exports = __webpack_public_path__ + "5ecc294b7bc5addd8fc21d8fdc328ef4.MP3";